module.exports = __webpack_public_path__ + "static/media/shopping.6d629e52.svg";